import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslationEditorModule } from '@fry/booking/translation-editor';
import { FryCommonModule } from '@fry/components/common';
import { UserFieldsRoutingModule } from '@fry/components/user-fields/user-fields-routing.module';
import { UserFieldAddComponent } from '@fry/components/user-fields/user-field-add/user-field-add.component';
import { UserFieldEditComponent } from '@fry/components/user-fields/user-field-edit/user-field-edit.component';
import { UserFieldListComponent } from '@fry/components/user-fields/user-field-list/user-field-list.component';
import { UserFieldsComponent } from '@fry/components/user-fields/user-fields/user-fields.component';
import { MaterialModule } from '@fry/components/material';
import { UnboxedModule } from '@fry/ui';

import { UserFieldForm } from './user-field.form';
import { UserFieldsSearch } from './user-fields.search';
import { UserFieldSlotComponent } from './user-field-slot/user-field-slot.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FryCommonModule,
    UserFieldsRoutingModule,
    MaterialModule,
    UnboxedModule,
    TranslationEditorModule
  ],
  declarations: [
    UserFieldsComponent,
    UserFieldListComponent,
    UserFieldAddComponent,
    UserFieldEditComponent,
    UserFieldSlotComponent
  ],
  providers: [
    UserFieldsSearch,
    UserFieldForm
  ]
})
export class UserFieldsModule {}
